module.exports = __webpack_public_path__ + "static/media/venduta_obl.ac318d7a.png";